module.exports = __webpack_public_path__ + "static/media/kerfuffle.d4856ce5.png";